__webpack_public_path__ = window.publicPath;
console.log(
  "===== this is webpack startup code, setting public path to:",
  __webpack_public_path__
);
// since i just added a other module to the runtime, it ends up being the last module returned to the scope.
// For now, we need to re-export the container to the scope.
// you could use webpack internals to make this more dynamic, bue we will likely provide a internalized solution to attach a startup module
console.log(
  "account module ",
  __webpack_require__("webpack/container/entry/account")
);
Object.assign(window, {
  account: __webpack_require__("webpack/container/entry/account")
});
